<template>
    <div id="android-banner">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'OSS Configs',
                    to: { path: '/landing-banners' },
                    exact: true,
                },
                {
                    text: 'Banner Android',
                },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Banner Android</h3>

        <v-card>
            <v-card-title>
                Daftar Banner
                <v-spacer></v-spacer>
                <v-btn
                    id="oss_config_android_banner_tambah"
                    class="align-center text-body-2 blew white--text"
                    text
                    @click="
                        $router.push({ path: '/android-banners/form?baru=1' })
                    "
                    ><v-icon small class="pr-2">mdi-plus-circle</v-icon>
                    Buat Banner
                </v-btn>
            </v-card-title>

            <v-divider />

            <app-datatable
                :items="Banners"
                :headers="headers"
                :hasDetail="true"
                :custom-pagination-total-items="Banners.length"
                :custom-pagination-per-page="10"
                :custom-pagination-current-page="1"
                v-on:selected="selectedRow = $event"
                v-on:dblClicked="editBanner()"
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:doSearch="
                    search = { query: $event.value, by: headersKey[$event.key] }
                "
            ></app-datatable>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";

export default {
    name: "LandingPackageList",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            Banners: [],
            datas: null,
            selectedRow: null,
            isLoading: false,
            search: null,
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            headers: [
                { text: "ID", value: "id" },
                { text: "Link", value: "link" },
                { text: "Type", value: "type" },
                { text: "In Home", value: "is_home" },
                { text: "In Live Class", value: "is_live_class" },
                { text: "Aksi", value: "actions" },
            ],
            headersKey: ["id", "link", "type"],
        };
    },

    mounted: function () {
        this.fetchDatas();
    },

    methods: {
        async fetchDatas() {
            var context = this;
            this.isLoading = true;
            try {
                const resp = await this.$alioss.get(`/config/home`);
                this.datas = JSON.parse(resp.res.data).ads;
                this.$store.commit("android_banners_init", this.datas);
                this.$store.commit(
                    "android_banners_init_raw",
                    JSON.parse(resp.res.data),
                );

                this.datas.forEach(function (banner, index) {
                    var row = {
                        no: index,
                        id: banner.id,
                        link: banner.link,
                        type: banner.type,
                        image: banner.image,
                        is_restricted: !banner.is_active,
                        is_home: !banner.is_home,
                        is_live_class: !banner.is_live_class,
                        datas: banner,
                    };

                    context.Banners.push(row);

                    context.isLoading = false;
                });
                context.isLoading = false;
            } catch (error) {
                // isLoading hanya direset di jalur sukses, jadi tanpa baris ini
                // spinner berputar selamanya saat OSS gagal.
                context.isLoading = false;
                alert(error);
            }
        },

        editBanner() {
            var context = this;
            this.$store.commit(
                "android_banners_onedit",
                this.selectedRow.datas,
            );
            context.$router.push("/android-banners/form");
        },
    },
};
</script>



// WEBPACK FOOTER //
// ListBanner.vue?246f2f9e